export const NOTIFICATION_SETTING_ALL = 'ALL';
export const NOTIFICATION_SETTING_NONE = 'NONE';
export const NOTIFICATION_SETTING_SOME = 'SOME';

export const NOTIFICATIONS_SETTINGS_ROUTE_VISIT_EVENT_TYPE = 'ROUTE_VISIT';
export const NOTIFICATIONS_SETTINGS_APPROVAL_REQUEST_EVENT_TYPE = 'SITE_APPROVAL_REQUEST';
export const NOTIFICATIONS_SETTINGS_SITE_ASSIGNMENT_EVENT_TYPE = 'SITE_ASSIGNMENT';
export const NOTIFICATIONS_SETTINGS_ACCESS_REQUEST_EVENT_TYPE = 'SITE_ACCESS_REQUEST';
export const NOTIFICATIONS_SETTINGS_FORM_RESPONSE_EVENT_TYPE = 'FORM_RESPONSE';
